import PropTypes from "prop-types"
import classNames from "classnames"
import { findIndex, map, size } from "lodash"
import { Link } from "react-router-dom"
import { Card, Tabs } from "@mui/material"
import UpsellTab from "./upsell-tab"
import { UPSELL_TABS_SHAPE } from "./shapes"

import "./styles.scss"

export default function UpsellTabs({ id, tabs }) {
  // Don't display tabs if there is only one option
  if (size(tabs) <= 1) { return null }

  const selectedTabIndex = findIndex(tabs, ({ selected }) => selected)
  const renderedTabs = <Tabs
    id={id}
    value={selectedTabIndex}
    indicatorColor="primary"
    textColor="primary"
    className={classNames("upsell-tabs", id)}
  >
    {map(tabs, (tab, index) => <UpsellTab key={tab.id} component={Link} {...tab} selected={selectedTabIndex === index} />)}
  </Tabs>

  return <Card className="upsell-tabs-card" square elevation={1}>
    {renderedTabs}
  </Card>
}

UpsellTabs.propTypes = {
  id: PropTypes.string.isRequired,
  tabs: UPSELL_TABS_SHAPE,
}

// For easy usage when you call the component
// e.g. import Tabs, { UPSELL_TABS_SHAPE } from 'components/material/upsell-tabs'
export { UPSELL_TABS_SHAPE }
